import React from 'react';
import { isArray } from 'lodash/fp';

function mapBindEvents(ref, ev, cb) {
  if (cb && !isArray(ev)) {
    mapBindEvents(ref, [[ev, cb]]);
  } else {
    ev.map(([e, cb]) => ref.current.addEventListener(e, cb));
  }
}
function mapUnbindEvents(ref, ev, cb) {
  if (cb && !isArray(ev)) {
    mapUnbindEvents(ref, [[ev, cb]]);
  } else {
    ev.map(([e, cb]) => ref.current.removeEventListener(e, cb));
  }
}
export default function(ev, cb, cond = []) {
  const ref = React.useRef();

  React.useLayoutEffect(() => {
    if (ref && ref.current) mapBindEvents(ref, ev, cb);

    return function() {
      if (ref && ref.current) mapUnbindEvents(ref, ev, cb);
    };
  }, [ref, ...cond]);
  return ref;
}
